export const AUTHENTICATE = '[Auth] Authenticate'
export const AUTHENTICATE_SUCCESS = '[Auth] Authenticate Success'
export const AUTHENTICATE_ERROR = '[Auth] Authenticate Error'
export const authenticate = ({ email, password }) =>
  ({ type: AUTHENTICATE, payload: { email, password } })

export const LOGOUT = '[Auth] Logout'
export const logout = () => ({ type: LOGOUT })